import { render, staticRenderFns } from "./main-professionalism.vue?vue&type=template&id=c5b884c6&scoped=true"
import script from "./main-professionalism.vue?vue&type=script&lang=js"
export * from "./main-professionalism.vue?vue&type=script&lang=js"
import style0 from "./main-professionalism.vue?vue&type=style&index=0&id=c5b884c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b884c6",
  null
  
)

export default component.exports